import { format, isToday, isYesterday } from "date-fns";

/** "now", "5m", "3h", "Mon", "12 Oct" - for the conversation list. */
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const date = new Date(iso);
  const ms = Date.now() - date.getTime();
  if (Number.isNaN(ms)) return "";
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return "now";
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  if (hours < 24 * 6) return format(date, "EEE");
  if (date.getFullYear() === new Date().getFullYear()) return format(date, "d MMM");
  return format(date, "d MMM yyyy");
}

/** "Today", "Yesterday" or "Mon, 12 Oct 2026" - the separators between days. */
export function dayLabel(iso: string): string {
  const date = new Date(iso);
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";
  return format(date, "EEE, d MMM yyyy");
}

/** "3:05 PM" - under each message. */
export function timeLabel(iso: string): string {
  return format(new Date(iso), "h:mm a");
}

/** The calendar day of a timestamp, local time, for grouping. */
export function dayKey(iso: string): string {
  return format(new Date(iso), "yyyy-MM-dd");
}
